export const layoutText = {
    //title: "Integration service | Vromo - shopify",
    integrationSrv: "integration service"
}